import axios from 'axios';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState([]);

  const navigate = useNavigate();

 const handlesubmit = async (e) => {
  e.preventDefault();

  // Clear previous errors
  setErrors([]);

  if (password !== confirmPassword) {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Passwords do not match!',
      customClass: {
         confirmButton: 'my-swal-btn'
  }
    });
    return;
  }

  try {
    const response = await axios.post(`https://trakersmallbusienss-3.onrender.com/api/auth/register`, {
      name,
      email,
      password,
    });


   localStorage.setItem('token', response.data.token);

    Swal.fire({
      icon: 'success',
      title: 'Registered Successfully!',
      showConfirmButton: false,
      timer: 1500,
    });

    navigate('/dashboard');

  } catch (error) {
    let errorMessages = [];

    if (error.response?.data?.errors) {
      // Expected format from backend
      errorMessages = error.response.data.errors;
    } else if (typeof error.response?.data === 'string') {
      // Backend returned a plain string
      errorMessages = [{ msg: error.response.data }];
    } else {
      // Fallback error
      errorMessages = [{ msg: error.message || 'Registration failed' }];
    }

    setErrors(errorMessages);

    Swal.fire({
      icon: 'error',
      title: 'Registration Failed',
      html: errorMessages.map((e) => `<p>${e.msg}</p>`).join(''),
          customClass: {
         confirmButton: 'my-swal-btn'
  }
    });
  }
};

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 card">
        <div>
          <h2 className="text-center text-3xl font-extrabold text-gray-900 dark:text-white">
            Create your account
          </h2>
        </div>

        <form className="mt-8 space-y-6">
          <div className="space-y-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Full Name
              </label>
              <input
                id="name"
                name="name"
                type="text"
                autoComplete="name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="input-field mt-1"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-field mt-1"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="new-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-field mt-1"
              />
            </div>

            <div>
              <label htmlFor="confirm-password" className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Confirm Password
              </label>
              <input
                id="confirm-password"
                name="confirm-password"
                type="password"
                autoComplete="new-password"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="input-field mt-1"
              />
            </div>
          </div>

          <div>
            <button type="submit" className="w-full btn-primary" onClick={handlesubmit}>
              Register
            </button>
          </div>

          <div className="text-center text-sm">
            <p className="text-gray-600 dark:text-gray-400">
              Already have an account?{' '}
              <Link to="/login" className="text-primary-600 dark:text-primary-400 hover:underline">
                Log in here
              </Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Register;
